__turbopack_context__.v({
  "wrp": "applicationWrp-module-scss-module__5DlVTG__wrp",
});
